var geo = {};
geo.init = function () {
  if (!document.getElementById('closeBtn')) return;
  if (!document.getElementById('js-geo-modal-wrapper')) return;
  if (!document.getElementById('geoModal')) return;
  if (!document.getElementById('js-newsletter-modal')) return;
  if (document.getElementById('geoModal').dataset.newsmodal) {
    document.getElementById('js-newsletter-modal').style.display = 'none';
  }
  document.getElementById('closeBtn').addEventListener('click', function () {
    document.getElementById('geoModal').style.display = 'none';
    document.getElementById('js-geo-modal-wrapper').style.display = 'none';
    document.getElementById('js-newsletter-modal').style.display = 'block';
  });
  document.getElementById('js-geo-modal-wrapper').addEventListener('click', function () {
    document.getElementById('geoModal').style.display = 'none';
    document.getElementById('js-geo-modal-wrapper').style.display = 'none';
    document.getElementById('js-newsletter-modal').style.display = 'block';
  });
};

//this is not in used
document.addEventListener('DOMContentLoaded', function () {
  // geo.init();
});


// WEBPACK FOOTER //
// ./scripts/components/geo.js